export const filterCandidatesForPrintMaterials = ({ candidates, filterType, searchText }) => {
  const allCandidates = Array.isArray(candidates) ? candidates : [];
  let filteredCandidates = allCandidates;

  if (filterType === 'prescreen') {
    filteredCandidates = allCandidates.filter((candidate) => {
      return candidate.PrescreenScoreAsDecimal != null;
    });
  } else if (filterType !== 'all') {
    filteredCandidates = allCandidates.filter((candidate) => {
      return candidate.pk_InterviewDate == filterType;
    });
  }

  const normalizedSearchText = (searchText || '').trim().toLowerCase();
  if (!normalizedSearchText) {
    return filteredCandidates;
  }

  return filteredCandidates.filter((candidate) => {
    const firstName = candidate.FirstName || '';
    const lastName = candidate.LastName || '';
    const candidateNames = [`${lastName}, ${firstName}`, `${firstName} ${lastName}`];

    return candidateNames.some((candidateName) => {
      return candidateName.toLowerCase().includes(normalizedSearchText);
    });
  });
};
